/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component, ViewEncapsulation,
  ChangeDetectionStrategy, Inject, HostListener, OnInit, OnDestroy, Input
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
  SeatMap, RowDataTypes, CabinTitleSeatMap,
  PositionTypes, RowDataSeatsMap, PassengersSeatMap, PassengersSeats
} from '@seat-map/entities/seat-map';
import { SeatMapFacade } from '@seat-map/seat-map.facade';
import { IS_BROWSER } from '@app/modules/core/tokens/app.tokens';
import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';
import { MobileDeviceService } from '@app/services/mobile-device.service';
import { AvoService } from '@avo/services/avo.service';
import { AvoDispatchOrchestrator } from '@avo/orchestrator/avo.dispatch';
import { ViewSeatmapFlightProperties } from '@app/modules/avo/Avo';


@Component({
  selector: 'app-seats-map',
  templateUrl: './seats-map.component.html',
  styleUrls: ['./seats-map.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SeatsMapComponent implements OnInit, OnDestroy {

  @Input() seatMapSeat: PassengersSeats[];
  @Input() seatMap: SeatMap;

  protected AvoDispatch = new AvoDispatchOrchestrator();

  public activeSelectUser: boolean;
  public topSelectUser: number;
  public topArrowSelectUser: number;
  public leftSelectUser: number;
  public leftListSelectUser: number;
  public widthListSelectUser: number;
  public maxHeightListSelectUser: number;
  public heightElementListSelectUser: number;
  public heightTitleElementListSelectUser: number;
  public positionTopListSelectUser: boolean;
  public countLenghtColumnsMapLarge: number;
  public subscriptions: Subscription[] = [];
  public isMobile: boolean;

  private seatNumberSelected: string;
  private changeSelectUser: boolean;

  constructor(
    private readonly facade: SeatMapFacade,
    private readonly domManiputaleService: DomManipulateService,
    private readonly mobileDeviceService: MobileDeviceService,
    private readonly avoService: AvoService,
    @Inject(IS_BROWSER) public isBrowser: boolean
  ) {
    this.topSelectUser = 0;
    this.topArrowSelectUser = 0;
    this.leftListSelectUser = 0;
    this.widthListSelectUser = 343;
    this.maxHeightListSelectUser = 230;
    this.heightElementListSelectUser = 58;
    this.heightTitleElementListSelectUser = 34;
    this.positionTopListSelectUser = false;
    this.countLenghtColumnsMapLarge = 7;
  }

  @HostListener('document:click', ['$event']) clickout(event: Event): void {
    if (this.isBrowser) {
      if (event['path']) {
        const inputButton = event['path'].find(paths =>
          !!paths['classList'] && paths['classList'].length > 0
          && paths['classList'].contains('list-select-user'));
        if (inputButton === undefined && this.activeSelectUser && !this.changeSelectUser) {
          this.facade.removePreviewSeatInFlightAction(this.seatNumberSelected);
          this.toogleSelectUser();
        }
        this.changeSelectUser = false;
      }
    }
  }

  ngOnInit(): void {
    this.setViewSeatmapFlightEvent();
    this.subscriptions.push(
      this.isMobile$.subscribe(isMobile => this.isMobile = isMobile)
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  get isMobile$(): Observable<boolean> {
    return this.mobileDeviceService.isMobileDevice$;
  }

  get rowDataTypes(): typeof RowDataTypes {
    return RowDataTypes;
  }

  get positionSpaceAisle(): PositionTypes {
    return PositionTypes.SpaceAisle;
  }

  public setViewSeatmapFlightEvent(): void {
    if (this.seatMap) {
      this.avoService.getEventTriggerProps$().pipe(
        tap(trigger => {
          return this.AvoDispatch.viewSeatmapFlight({
            ...this.avoService.avoBaseProperties(trigger),
            availableSeats: this.seatMap?.AvailableSeats
          } as unknown as ViewSeatmapFlightProperties);
        }
        )).subscribe().unsubscribe();
    }
  }

  public titleCabinClass(cabinTitle: CabinTitleSeatMap): string {
    return `SEAT_MAP_MODULE.CABIN_CLASS.${cabinTitle.Title}`;
  }

  public seatPositionSpaceAisle(location: PositionTypes): boolean {
    return location === this.positionSpaceAisle;
  }

  public isBoxLarge(seats: RowDataSeatsMap[]): boolean {
    return seats && seats.filter(x => x.Location === this.positionSpaceAisle).length > 1;
  }

  public toogleSelectUser(): void {
    this.activeSelectUser = !this.activeSelectUser;
    this.domManiputaleService.setBodyScroll(!this.activeSelectUser);
  }

  public selectBoxSeat(element: any, seatNumber: string, seat: RowDataSeatsMap, passengers: PassengersSeatMap[],
    passengersSeats: PassengersSeats[]): void {
    if (!this.seatAvailable(seat)) {
      return;
    }
    this.seatNumberSelected = seatNumber;
    if (passengers.length === 1) {
      this.facade.selectSeatPassengerInFlightAction(this.seatNumberSelected, passengers[0]);
    } else {
      this.facade.selectPreviewSeatInFlightAction(this.seatNumberSelected);
      this.openModalSelectUser(element, passengersSeats, passengers);
      this.toogleSelectUser();
      this.changeSelectUser = true;
    }
  }

  public seatAvailable(seat: RowDataSeatsMap): boolean {
    return !seat.Occupied && !seat.Inoperative && !seat.ErrorSelected;
  }

  public openModalSelectUser(element: any, passengersSeats: PassengersSeats[], passengers: PassengersSeatMap[]): void {
    const passengersSelected = passengersSeats.filter(x => x.SeatNumber);
    let heightListUsers = (this.heightElementListSelectUser * passengers.length) +
      (passengersSelected.length > 0 ? this.heightTitleElementListSelectUser : 0);
    heightListUsers = heightListUsers > this.maxHeightListSelectUser ? this.maxHeightListSelectUser : heightListUsers;
    const countTopPx = element.getBoundingClientRect().top + heightListUsers + this.heightElementListSelectUser;
    this.topArrowSelectUser = element.getBoundingClientRect().top;
    if (countTopPx > window.innerHeight) {
      this.positionTopListSelectUser = true;
      this.topSelectUser = element.getBoundingClientRect().top - heightListUsers - this.heightElementListSelectUser;
    } else {
      this.positionTopListSelectUser = false;
      this.topSelectUser = element.getBoundingClientRect().top;
    }
    this.leftSelectUser = element.getBoundingClientRect().left;
    this.openModalSelectUserCalculateLeft(element);
  }

  public openModalSelectUserCalculateLeft(element: any): void {
    if (this.isMobile) {
      const widthListUser = window.innerWidth <= this.widthListSelectUser ?
        window.innerWidth * 0.95 : this.widthListSelectUser;
      this.leftListSelectUser = (window.innerWidth - widthListUser) / 2;
      this.leftListSelectUser = this.leftListSelectUser < 0 ? this.leftListSelectUser * -1 : this.leftListSelectUser;
    } else {
      const countLeftPx = element.getBoundingClientRect().left - (this.widthListSelectUser / 2);
      this.leftListSelectUser = countLeftPx < 0 ? 0 :
        (countLeftPx + this.widthListSelectUser) > window.innerWidth ?
          window.innerWidth - this.widthListSelectUser : countLeftPx;
    }
  }

  public selectSeatPassenger(passenger: PassengersSeatMap): void {
    this.avoService.getEventTriggerProps$().pipe(
      tap(trigger => {
        if (passenger?.['SeatNumber'] !== this.seatNumberSelected) {
          this.AvoDispatch.selectSeatmapSeat({
            ...this.avoService.avoBaseProperties(trigger),
            itineraryId: this.seatMap?.ItineraryId,
            flightIndex: this.seatMap?.FlightIdx?.toString(),
          })
        }
      }
      )).subscribe().unsubscribe();

    this.facade.removePreviewSeatInFlightAction(this.seatNumberSelected);
    this.facade.selectSeatPassengerInFlightAction(this.seatNumberSelected, passenger);
    this.toogleSelectUser();

  }

  public isSelectSeat(passenger: PassengersSeatMap, passengersSeats: PassengersSeats[]): boolean {
    const _passenger = passengersSeats
      .find(x => x.SeatNumber && x.Surname === passenger.LastName && x.FirstName === passenger.FirstName);
    return !!_passenger;
  }

  public filterPassengerSelected(seatNumber: string, passengersSeats: PassengersSeats[]): string {
    const findPassenger = passengersSeats.find(x => x.SeatNumber === seatNumber);
    return findPassenger ? findPassenger.FirstName[0] + findPassenger.Surname[0] : '';
  }

  public filterPassengersSelected(passengersSeats: PassengersSeats[], selected: boolean): PassengersSeats[] {
    if (selected) {
      return passengersSeats.filter(x => x.SeatNumber);
    } else {
      return passengersSeats.filter(x => !x.SeatNumber);
    }
  }

  public seatMapIsLarge(columns: number): boolean {
    return columns > this.countLenghtColumnsMapLarge;
  }

  public seatMapIsLargeSeatMap(seatMap: SeatMap): boolean {
    return seatMap.Cabins[0].Rows[0].Data['length'] > this.countLenghtColumnsMapLarge;
  }
}

